import React from 'react';

export function RawHtml(props: { content: string }) {
    return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
}
